export default "__VITE_PUBLIC_ASSET__aa05c2d7__"